import { frontendURL } from 'dashboard/helper/URLHelper';
const CheckerListView = () => import('./List.vue');
const ConversationSummary = () => import('./ConversationSummary.vue');
import {
  ADMIN_PERMISSIONS,
  CHECKER_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/checker-view/:inboxId?/:tab?'),
    name: 'checker_view',
    component: CheckerListView,
    meta: {
      permissions: [ADMIN_PERMISSIONS, CHECKER_PERMISSIONS],
    },
  },
  {
    path: frontendURL('accounts/:accountId/conversation-summaries/:inboxId?'),
    name: 'conversation_summaries',
    component: ConversationSummary,
    meta: {
      permissions: [ADMIN_PERMISSIONS, CHECKER_PERMISSIONS],
    },
  },
];
